<!--调拨订单查看页面--->
<template>
  <el-dialog
    :title="getTitle()"
    :visible.sync="dialogSeeVisible"
    center
    :close-on-click-modal="false" :append-to-body="true"
    custom-class="max-dialog1256">
    <div ref="print1" style="width: 98%;margin: 0 auto;">
      <p :style="{display:showtitle1,textAlign:'center',fontSize:'18px',lineHeight:'40px'}">{{getTitle()}}</p>
      <p v-show="lockuname" style="color: red"><span>操作人：</span>{{lockuname}}<span>正在操作</span>
        <span @click="unlock"
              style="color: blue;cursor: pointer;">&nbsp;解除锁定</span>
      </p>
      <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
             class="print-table">
        <tr class="noborder" style="height: 26px">
          <td align="right">名&nbsp;&nbsp;&nbsp;称：</td>
          <td colspan="3">{{controlData.seedname}}</td>
          <td align="right" width="60">编&nbsp;&nbsp;&nbsp;码：</td>
          <td>{{controlData.seedcode}}</td>
        </tr>
        <tr class="noborder" style="height:26px">
          <td align="right" width="80">单&nbsp;&nbsp;&nbsp;号：</td>
          <td width="140">{{controlData.erpserial}}</td>
          <td align="right" width="80">登记日：</td>
          <td width="120">{{(controlData.adddate || "").substr(0, 10)}}</td>
          <td align="right" width="80">发货日：</td>
          <td width="180">{{(controlData.accdate|| "").substr(0, 10)}}</td>
        </tr>
        <tr class="noborder" style="height:26px">
          <td align="right" width="60">发货仓：</td>
          <td colspan="2">{{controlData.cangkuname}} <b style="font-size: larger">{{controlData.warehousename}}</b></td>
          <td colspan="3">{{controlData.cangkuaddress}}</td>
        </tr>
        <tr class="noborder" style="height:26px">
          <td align="right">收货仓：</td>
          <td colspan="2">{{controlData.cangkuname2}}
            <el-select v-model="warehouse" placeholder="请选择库位" size="mini" style="width: 120px" v-if="warehousearr.length>1&&controlData.cangkucode2&&opstatus=='shouhuo'&&this.controlData.status==0" @change="changewarehouse">
            <el-option v-for="item in warehousearr" :key="item.serial" :label="item.name" :value="item.serial"></el-option>
            </el-select>
            <span v-else>  {{controlData.warehousename2}}</span>
          </td>
          <td colspan="3">{{controlData.cangku1address}}</td>
        </tr>
        <tr class="noborder no-print" style="height: 26px;" v-if="opstatus=='fahuo'&&controlData.status==-10&&lock">
          <td align="right">物&nbsp;&nbsp;&nbsp;流：</td>
          <td>
            <el-select v-model="controlData.logisticsco" placeholder="请选择" size="mini">
              <el-option
                v-for="item in parameterData"
                :key="item.value"
                :label="item.name"
                :value="item.name">
              </el-option>
            </el-select>
          </td>
          <td align="right">单&nbsp;&nbsp;&nbsp;号：</td>
          <td colspan="3">
            <el-input v-model="controlData.logisticsnum" auto-complete="off" required="true" size="mini"
                      style="width: 180px;" placeholder="请填写发货单号"></el-input>
            <template v-if="controlData.logisticsnum">
              <el-button circle type="info" @click="OrderPrint" :loading="loading" icon="el-icon-printer" title="打印-快递单" size="mini"></el-button>
              <!--<el-button circle type="warning" @click="RouteService" icon="el-icon-truck" title="查询-物流" size="mini"></el-button>-->
              <el-button circle type="danger" @click="removeOrderService" :loading="loading" icon="el-icon-delete" title="撤销-快递单" size="mini"></el-button>
            </template>
            <el-button v-else circle type="success" @click="createOrderService" :loading="loading" icon="el-icon-edit" title="创建-快递单" size="mini"></el-button>
          </td>
        </tr>
        <tr class="noborder" style="height:26px" v-if="this.controlData.status==0||this.controlData.status==10">
          <td align="right">物&nbsp;&nbsp;&nbsp;流：</td>
          <td>{{controlData.logisticsco}}</td>
          <td align="right">单&nbsp;&nbsp;&nbsp;号：</td>
          <td>
            {{controlData.logisticsnum}}
            <el-button v-if="controlData.logisticsnum" class="no-print" circle type="info" @click="OrderPrint" :loading="loading" icon="el-icon-printer" title="打印-快递单" size="mini"></el-button>
          </td>
        </tr>
        <tr class="noborder no-print" v-if="opstatus&&jinjia!=40">
          <td align="right">商品码：</td>
          <td>
            <el-input v-model="goodsbarcode" size="mini" @change="selectbarcode" ref="goodsbarcode"
                      style="width: 125px"></el-input>
          </td>
          <td align="right"></td>
          <td></td>
          <td align="right"></td>
          <td></td>
        </tr>
        <!--镜片(非镜架/非定制)查看：默认表格列表(R/L、产品名称、球镜、柱镜、数量)，可切换二维表显示-->
        <tr v-show="showlenslist">
          <td colspan="6" style="border:none">
            <div class="no-print" style="margin-bottom: 6px">
              <el-radio-group v-model="lensViewMode" size="mini">
                <el-radio-button label="table">表格</el-radio-button>
                <el-radio-button label="twodim">二维表</el-radio-button>
              </el-radio-group>
            </div>
            <!--表格视图-->
            <table v-show="lensViewMode=='table'" cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
                   class="query-table">
              <tr>
                <td style="text-align: center;width: 50px">序号</td>
                <td style="text-align: center;width: 60px">R/L</td>
                <td style="text-align: left;min-width: 120px">产品名称</td>
                <td style="text-align: center;width: 80px">球镜</td>
                <td style="text-align: center;width: 80px">柱镜</td>
                <td style="text-align: center;width: 60px">数量</td>
              </tr>
              <tr v-for="(item,index) in lensList" :key="index">
                <td style="text-align: center">{{index+1}}</td>
                <td style="text-align: center">{{item['R/L']}}</td>
                <td style="text-align: left"><span class="lens-seed-name">{{item['产品名称']}}</span></td>
                <td style="text-align: center">{{item['球镜显示']}}</td>
                <td style="text-align: center">{{item['柱镜显示']}}</td>
                <td style="text-align: center">{{item['数量']}}</td>
              </tr>
              <tr v-if="lensList.length > 0">
                <td colspan="5" style="text-align: right;font-weight: bold;background:#f5f7fa;">数量合计</td>
                <td style="text-align: center;font-weight: bold;background:#f5f7fa;">{{ lensTotalNumber }}</td>
              </tr>
            </table>
            <!--二维表视图-->
            <div v-show="lensViewMode=='twodim'">
              <table v-show="showzuoyoutable" cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
                     class="print-table">
                <tr>
                  <td style="text-align: right;border:none;width: 10%">右眼：</td>
                  <td style="text-align: left;border:none;width: 40%">
                    <TwoDimensionalTable ref="referweibiaoright" :needSetHeight="false" :needSetDisabled="false"
                                         :erweitable="erweitableright"></TwoDimensionalTable>
                  </td>
                  <td style="text-align: right;border:none;width: 10%">左眼：</td>
                  <td style="text-align: left;border:none">
                    <TwoDimensionalTable ref="referweibiaoleft" :needSetHeight="false" :needSetDisabled="false"
                                         :erweitable="erweitableleft"></TwoDimensionalTable>
                  </td>
                </tr>
              </table>
              <TwoDimensionalTable v-show="showerweitable" ref="referweibiao" :needSetHeight="false" :needSetDisabled="false"
                                   :erweitable="erweitable"></TwoDimensionalTable>
            </div>
          </td>
        </tr>
        <tr v-show="showerweitable&&isshowbarcode&&jinjia!=80">
          <td colspan="6" style="border:none">
            <TwoDimensionalTable ref="barcodereferweibiao" :needSetHeight="false" :needSetDisabled="false"
                                 :erweitable="barcodeerweitable"></TwoDimensionalTable>
          </td>
        </tr>
        <tr v-show="showzuoyoutable&&isshowbarcode&&jinjia!=80">
          <td colspan="6" style="border:none">
            <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
                   class="print-table">
              <tr>
                <td style="text-align: right;border:none;width: 10%">右眼：</td>
                <td style="text-align: left;border:none;width: 40%">
                  <TwoDimensionalTable ref="barcodereferweibiaoright" :needSetHeight="false" :needSetDisabled="false"
                                       :erweitable="barcodeerweitableright"></TwoDimensionalTable>
                </td>
                <td style="text-align: right;border:none;width: 10%">左眼：</td>
                <td style="text-align: left;border:none">
                  <TwoDimensionalTable ref="barcodereferweibiaoleft" :needSetHeight="false" :needSetDisabled="false"
                                       :erweitable="barcodeerweitableleft"></TwoDimensionalTable>
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <tr v-show="jinjia==40">
          <td align="right">数量：</td>
          <td style="margin-bottom: 10px;margin-top: 10px">
            {{totalnumber}}
          </td>
        </tr>
        <tr v-if="jinjia==80">
          <td colspan="6" style="text-align: right">总数:{{totalnumber}}</td>
        </tr>
        <tr v-if="jinjia==80">
          <td colspan="6">
            <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
                   class="query-table">
              <tr>
                <td style="text-align: center;width: 50px">序号</td>
                <td style="text-align: center;min-width: 90px">产品名称</td>
                <td style="text-align: center;min-width: 50px">编码</td>
                <td style="text-align: center;min-width: 50px">型号</td>
                <td style="text-align: center;min-width: 50px">色号</td>
                <td style="text-align: center;width: 50px">数量</td>
                <!--<td style="text-align: center;width: 140px" v-if="showtitle1=='none'">条码</td>-->
              </tr>
              <!--表头结束-->
              <tr v-for="(item,index) in tableData">
                <td style="text-align: center">{{index+1}}</td>
                <td>{{item["seedname"]}}</td>
                <td>{{item["seedcode"]}}</td>
                <td>{{item["model"]}}</td>
                <td>{{item["color"]}}</td>
                <td>{{item["totalnumber"]}}</td>
                <!--<td v-if="showtitle1=='none'"><div style="float: left;width: 98%" v-for="(co,index) in item.barcodes">{{co.c}}</div></td>-->
              </tr>
            </table>
          </td>
        </tr>
        <tr class="noborder" style="height:26px">
          <td>说明：</td>
          <td colspan="5" style="text-align: left">
            <div v-html="getLiuYan(controlData.remark)"></div>
          </td>
        </tr>

        <tr class="noborder" style="height:26px">
          <td colspan="4">&nbsp;&nbsp;&nbsp;&nbsp;开单人员：{{controlData.uname}}</td>
          <td colspan="2">发货人员：{{controlData.logisticsuname}}</td>
        </tr>
      </table>
    </div>
    <div slot="footer" class="dialog-footer no-print">
      <el-button @click="dialogSeeVisible = false">取 消</el-button>
      <el-button type="success" @click="delivergoodsScan" class="qrbtn" v-if="(showerweitable||showzuoyoutable)&&paramqrcodescan" :loading="loading">扫码</el-button>
      <el-button type="primary" :loading="loading" v-if="opstatus=='fahuo'&&controlData.status==-10&&lock"
                 @click="fahuo()">确定发货
      </el-button>
      <el-button type="primary" :loading="loading" v-if="opstatus=='shouhuo'&&controlData.status==0"
                 @click="handlesaleCsagreementToVoid()">确定收货
      </el-button>
      <el-button type="primary" @click="print1" v-if="!lockuname">打印</el-button>
      <span @click="printloglook" style="position: absolute;bottom: 8px;right: 10px">{{tips()}}</span>
    </div>
    <printlogList ref="printlogList"></printlogList>
    <HandlelogList ref="HandlelogList"></HandlelogList>
    <QRCodeScan ref="QRCodeScan1" @scancodeedit="afterQRCodeScan"></QRCodeScan>
    <!--镜片商品二维码显示弹窗（点击列表商品名称打开，兼顾左右眼）-->
    <el-dialog
      :title="qrTitle"
      :visible.sync="qrvisible"
      center
      :close-on-click-modal="false" :append-to-body="true"
      custom-class="max-dialog1256">
      <div ref="print1qr" style="width: 98%;margin: 0 auto;">
        <p :style="{display:qrshowtitle1,textAlign:'center',fontSize:'18px',lineHeight:'40px'}">{{qrTitle}}</p>
        <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
               class="print-table">
          <tr class="noborder" style="height: 26px">
            <td align="right">名&nbsp;&nbsp;&nbsp;称：</td>
            <td colspan="3">{{controlData.seedname}}</td>
            <td align="right" width="60">编&nbsp;&nbsp;&nbsp;码：</td>
            <td>{{controlData.seedcode}}</td>
          </tr>
          <tr class="noborder" style="height:26px">
            <td align="right" width="80">单&nbsp;&nbsp;&nbsp;号：</td>
            <td width="140">{{controlData.erpserial}}</td>
            <td align="right" width="80">登记日：</td>
            <td width="120">{{(controlData.adddate || "").substr(0, 10)}}</td>
            <td align="right" width="80">发货日：</td>
            <td width="180">{{(controlData.accdate|| "").substr(0, 10)}}</td>
          </tr>
          <tr class="noborder" style="height:26px">
            <td align="right" width="60">发货仓：</td>
            <td colspan="2">{{controlData.cangkuname}} <b style="font-size: larger">{{controlData.warehousename}}</b></td>
            <td colspan="3">{{controlData.cangkuaddress}}</td>
          </tr>
          <tr class="noborder" style="height:26px">
            <td align="right">收货仓：</td>
            <td colspan="2">{{controlData.cangkuname2}} {{controlData.warehousename2}}</td>
            <td colspan="3">{{controlData.cangku1address}}</td>
          </tr>
          <tr class="noborder" style="height:26px" v-if="this.controlData.logisticsco||this.controlData.logisticsnum">
            <td align="right">物&nbsp;&nbsp;&nbsp;流：</td>
            <td>{{controlData.logisticsco}}</td>
            <td align="right">单&nbsp;&nbsp;&nbsp;号：</td>
            <td>{{controlData.logisticsnum}}</td>
          </tr>
          <tr v-show="showzuoyoutable">
            <td colspan="6" style="border:none">
              <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
                     class="print-table">
                <tr>
                  <td style="text-align: right;border:none;width: 10%">右眼：</td>
                  <td style="text-align: left;border:none;width: 40%">
                    <TwoDimensionalTable ref="qrreferweibiaoright" :needSetHeight="false" :needSetDisabled="false"></TwoDimensionalTable>
                  </td>
                  <td style="text-align: right;border:none;width: 10%">左眼：</td>
                  <td style="text-align: left;border:none">
                    <TwoDimensionalTable ref="qrreferweibiaoleft" :needSetHeight="false" :needSetDisabled="false"></TwoDimensionalTable>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr v-show="showerweitable">
            <td colspan="6" style="border:none">
              <TwoDimensionalTable ref="qrreferweibiao" :needSetHeight="false" :needSetDisabled="false"></TwoDimensionalTable>
            </td>
          </tr>
          <tr class="noborder" style="height:26px">
            <td colspan="6">&nbsp;&nbsp;&nbsp;&nbsp;开单人员：{{controlData.uname}}</td>
          </tr>
        </table>
      </div>
      <div slot="footer" class="dialog-footer no-print">
        <el-button @click="qrvisible = false">关 闭</el-button>
        <el-button type="primary" @click="print1qr">打印</el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>


<script>

  import {getjxcList,getDetail, receiveAllocation, saveAllocationStore} from '@/api/set/allocation';
  import {getRemark} from '@/plugin/ordercommon';
  import printlogList from '@/components/testorder/cstagreement/printlogList'
  import HandlelogList from '@/components/testorder/cstagreement/HandlelogList'
  import {save} from '@/api/order/printlog';
  import {printing} from '@/api/set/csagreement';
  import {getPrice} from '@/api/set/goodsprice';
  import {sfOrderService, sfOrderConfirm,sfRouteService,sfOrderPrint,loadPrintFile} from '@/api/order/express';
  import TwoDimensionalTable from '@/components/set/goodsprice/TwoDimensionalTable';
  import {getParameterDetail} from '@/api/set/parameter';
  import {bardetail} from '@/api/set/jxcgoodsbarcode';
  import {saveData as logsaveData, getListData as logListData, lockremove} from '@/api/set/handlelog';
  import QRCodeScan from '@/components/testorder/buyagreement/QRCodeScan';
  import {checkModuleRight} from '@/api/login'
  import {listBar,copyBars} from '@/api/set/jxcstoregoodsbar';

  export default {
    name: 'AllocationDetail',
    msg: '调拨单处理页面',
    data() {
      return {
        opstatus: '',
        formLabelWidth: '120px',
        row: {},
        dialogSeeVisible: false,
        loading: false,
        seedcode: "",
        unitguid: "",
        column: [],
        totalnumber:0,
        isdeliverShow: false,
        parameterData: [],
        controlData: {
          logisticsco: '',
          logisticsnum: '',
        },
        showtitle1: "none",
        erpserial: '',
        printData: [],//打印日志
        uname: '',//最新一条打印人员
        adddate: '',//最新一条打印时间
        warehousearr:[],
        warehouse:'',
        warehousename:'',
        erweitable: [],
        erweitableleft: [],
        erweitableright: [],
        barcodeerweitable: [],//商品条码扫码后用到
        barcodeerweitableleft: [],//商品条码扫码后用到
        barcodeerweitableright: [],//商品条码扫码后用到
        costpricebook: {},
        BookContent: [],
        BookContentLeft: [],
        BookContentRight: [],
        barcodeBookContent: [],//商品条码扫码后用到
        barcodeBookContentLeft: [],//商品条码扫码后用到
        barcodeBookContentRight: [],//商品条码扫码后用到
        showzuoyoutable: false,
        showerweitable: false,
        goodsbar: {},//商品条码信息
        goodsbarcode: '',
        isshowbarcode: false,//是否已经扫码确认数量
        barpackagesize: {},//商品条码光度信息
        lock: true,//锁定订单
        lockuname: '',//正在操作的人
        jinjia: '',
        paramqrcodescan:false,
        tableData: [],
        lensList: [],//镜片列表显示数据(R/L、产品名称、球镜、柱镜、数量)
        qrvisible: false,//镜片二维码弹窗是否显示
        qrshowtitle1: 'none',//二维码弹窗打印标题
        qrTitle: '',//二维码弹窗标题
        lensViewMode: 'table',//镜片查看显示模式：'table'表格列表 / 'twodim'二维表
      }
    },
    computed: {
      //镜片(非镜架80、非定制40)查看时以列表显示
      showlenslist() {
        return this.jinjia != 80 && this.jinjia != 40;
      },
      //镜片表格视图数量合计
      lensTotalNumber() {
        let total = 0;
        for (let i in this.lensList) {
          let n = parseInt(this.lensList[i]['数量']);
          if (!isNaN(n)) total += n;
        }
        return total;
      }
    },
    methods: {
      createOrderService() {
        this.loading=true
        sfOrderService({
          unitguid: this.controlData.erpserial,
          cangkucode: this.controlData.cangkucode,//发货仓
          cangkucode2: this.controlData.cangkucode2,//收货仓
          paymethod: this.controlData.logisticsco
        }).then(response => {
          if (response.data.code == 0) {
            this.controlData.logisticsnum = response.data.msg;
            if (response.data.express) {
              this.$message({
                message: '已创建过快递单！',
                type: 'error'
              })
              this.controlData.logisticsco = response.data.express
            }

            if (response.data.printurl)
              this.OrderPrintFile(response.data.printurl);
            else{
              this.loading=false
            }
          } else {
            this.$message({
              message: response.data.msg,
              type: 'error'
            })
            this.loading=false
          }
        });
      },
      RouteService() {
        sfRouteService({erpserial: this.controlData.erpserial, expressno: this.controlData.logisticsnum}).then(response => {
          var newarrr = []
          for (let i in this.supplystatuslist) {
            if (!this.supplystatuslist[i].express) {
              newarrr.push(this.supplystatuslist[i])
            }
          }
          for (let i in response.data.obj) {
            var row = response.data.obj[i]
            newarrr.push({FlagCode: row.status, FlagDateTime: row.time, express: true})
          }
          this.supplystatuslist = newarrr;
          this.supplydrawer = true;
        });
      },
      OrderPrint() {
        this.loading=true
        sfOrderPrint({erpserial: this.controlData.erpserial,expressno:this.controlData.logisticsnum}).then(response => {
          if(response.data.code==1){
            this.$message({message: response.data.msg,type: 'error'});
            this.loading=false
            return;
          }
          this.OrderPrintFile(response.data.printurl);
        });
      },
      OrderPrintFile(printurl) {
        var thisFun=this;
        loadPrintFile(printurl,this.controlData.cangkucode,function () {
          thisFun.$message({
            message: '已发送到打印机！',
            type: 'success'
          })
          thisFun.loading = false;
        });
      },
      removeOrderService() {
        this.loading=true
        this.$confirm("是否确定撤销快递单？", '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          sfOrderConfirm({erpserial: this.controlData.erpserial,expressno:this.controlData.logisticsnum}).then(response => {
            if (response.data.code == 0) {
              this.controlData.logisticsnum = '';
              this.$message({
                message: '已成功取消',
                type: 'success'
              })
            } else {
              this.$message({
                message: response.data.msg,
                type: 'error'
              })
            }
            this.loading=false
          })
        }).catch(() => {
          this.loading=false
          this.$message({
            type: 'info',
            duration: 1500,
            message: '已取消'
          });
        });
      },
      delivergoodsScan() {//扫码发货
        if (this.opstatus=='fahuo'&&this.controlData.status==-10&&(!this.controlData.logisticsnum || this.controlData.logisticsnum == "")) {
          this.$message.error('物流方式必须选择！');
          return;
        }
        var arr = []
        for (let i in this.erweitable) {
          let temp = this.erweitable[i].filter((t) => {
            return typeof(t.P) != "undefined" && t.P !== "" && parseInt(t.P) !== 0;
          })
          for (let j in temp) {
            for (let m = 0; m < temp[j].P; m++) {
              arr.push({
                seedcode: this.controlData.seedcode,
                seedname: this.controlData.seedname,
                packagesize: '{"X":"' + (temp[j].X.toFixed(2)) + '","Y":"' + (temp[j].Y.toFixed(2)) + '"}',
                storegoodsbarcode: '',starttime: '',endtime: ''
              })
            }
          }
        }
        this.$refs.QRCodeScan1.show({
          cangkucode: this.controlData.cangkucode,
          erpserial: this.controlData.erpserial,
          seedcode: this.controlData.seedcode,
          goods: arr
        }, this.opstatus=='fahuo');
      },
      afterQRCodeScan(scancodes) {//扫码后提交(退货时才有)
        this.fahuo();
      },
      changewarehouse(val){
        this.warehouse = val;
        for(let i in this.warehousearr){
          if(this.warehousearr[i].serial==val){
            this.warehousename = this.warehousearr[i].name;
            break;
          }
        }
      },
      //购买总数
      totalNumber() {
        this.totalnumber = 0
        for (let i in this.tableData) {
          this.totalnumber = this.totalnumber + parseInt(this.tableData[i].totalnumber)
        }
      },
      //处理日志
      handlelog(casestepname) {
        var handlelog = {}
        handlelog.erpserial = this.erpserial
        handlelog.isopen = 1
        handlelog.casestepname = casestepname
        handlelog.remark = '调拨发货'
        logsaveData(handlelog).then(response => {
        })
      },
      //解除锁定
      unlock() {
        var casestepname = '调拨发货';
        lockremove({
          erpserial: this.erpserial
        }).then(response => {
          if (response.data.code == 0) {
            this.lock = true
            this.lockuname = ''
            //锁定功能(控制发起采购按钮)
            this.handlelog(casestepname);
          } else {
            this.$message({
              message: response.data.msg,
              type: 'error'
            })
          }
        })
      },
      //商品条码
      selectbarcode(val) {
        if (!val)
          return;
        this.goodsbarcode = '';
        this.barpackagesize = ''
        var obj = {
          barcode: val
        }
        bardetail(obj).then(response => {
          this.goodsbar = response.data.obj
          //商品不存在提示
          if (this.goodsbar == undefined) {
            this.$message({
              message: '条码无效',
              type: 'error'
            })
            return
          } else {
            this.isshowbarcode = true
            if (this.jinjia == 80) {//镜架扫码
              this.packagesize()
              return
            }

            if(this.goodsbar.seedcode!=this.controlData.seedcode){
              this.$message({
                message: '商品不正确',
                type: 'error'
              })
              return
            }

            this.barpackagesize = JSON.parse(this.goodsbar.packagesize)
            if (this.barpackagesize.P == undefined) {
              this.barpackagesize.P = 0
            }
            if (this.barpackagesize.type != undefined) {
              this.packagesize()
            } else {
              this.packagesize()
            }

          }

        })

      },
      //商品扫码数量确认
      packagesize() {
        var compare = true//控制 商品光度 不存在提示
        if (this.barpackagesize.type == "L") {
          for (let i in this.BookContentLeft) {
            var packagesizeleft = this.BookContentLeft[i]
            if (packagesizeleft.X == this.barpackagesize.X && packagesizeleft.Y == this.barpackagesize.Y) {
              compare = false
              //相同光度将上次扫码的数量获取出来
              if (this.barcodeBookContentLeft.length > 0) {
                for (let i in this.barcodeBookContentLeft) {
                  if (this.barcodeBookContentLeft[i].X == this.barpackagesize.X && this.barcodeBookContentLeft[i].Y == this.barpackagesize.Y) {
                    this.barpackagesize.P = this.barcodeBookContentLeft[i].P
                  }
                }
              }
              //对应的商品数量小于扫码数量提示已达上限，否则继续加1
              if (packagesizeleft.P > this.barpackagesize.P) {
                this.barpackagesize.P++
                this.barcodeBookContentLeft = []
                this.barcodeBookContentLeft.push(this.barpackagesize)
                this.$message({
                  message: JSON.stringify(this.barpackagesize) + '扫码成功',
                  type: 'success',
                })
              } else {
                this.$alert('该' + JSON.stringify(this.barpackagesize) + '已达到上限', '提示', {
                  confirmButtonText: '确定',
                  callback: action => {
                    this.$message({
                      type: 'info',
                      message: `请继续扫码!`
                    });
                  }
                });
                this.goodsbarcode = ''
                return
              }
            }
          }
        } else if (this.barpackagesize.type == "R") {
          for (let i in this.BookContentRight) {
            var packagesizeright = this.BookContentRight[i]
            if (packagesizeright.X == this.barpackagesize.X && packagesizeright.Y == this.barpackagesize.Y) {
              compare = false
              //相同光度将上次扫码的数量获取出来
              if (this.barcodeBookContentRight.length > 0) {
                for (let i in this.barcodeBookContentRight) {
                  if (this.barcodeBookContentRight[i].X == this.barpackagesize.X && this.barcodeBookContentRight[i].Y == this.barpackagesize.Y) {
                    this.barpackagesize.P = this.barcodeBookContentRight[i].P
                  }
                }
              }
              //对应的商品数量小于扫码数量提示已达上限，否则继续加1
              if (packagesizeright.P > this.barpackagesize.P) {
                this.barpackagesize.P++
                this.barcodeBookContentRight = []
                this.barcodeBookContentRight.push(this.barpackagesize)
                this.$message({
                  message: JSON.stringify(this.barpackagesize) + '扫码成功',
                  type: 'success',
                })
              } else {
                this.$alert('该' + JSON.stringify(this.barpackagesize) + '已达到上限', '提示', {
                  confirmButtonText: '确定',
                  callback: action => {
                    this.$message({
                      type: 'info',
                      message: `请继续扫码!`
                    });
                  }
                });
                this.goodsbarcode = ''
                return
              }
            }
          }
        } else if (this.jinjia == 80) {//镜架扫码
          var datalist = JSON.parse(JSON.stringify(this.tableData))
          for (let i in  datalist) {
            if (datalist[i].seedcode == this.goodsbar.seedcode) {
              if (datalist[i].totalnumber == datalist[i].P) {
                this.$alert('该商品' + datalist[i].seedname + '已达到上限', '提示', {
                  confirmButtonText: '确定',
                  callback: action => {
                    this.$message({
                      type: 'info',
                      message: `请继续扫码!`
                    });
                  }
                });
                this.goodsbarcode = ''
                return
              }
              compare = false
              datalist[i].P = datalist[i].P + 1;
            }
          }
          this.tableData = JSON.parse(JSON.stringify(datalist))
        } else {
          for (let i in this.BookContent) {
            var packagesizes = this.BookContent[i]
            if (packagesizes.X == this.barpackagesize.X && packagesizes.Y == this.barpackagesize.Y) {
              compare = false
              //相同光度将上次扫码的数量获取出来
              if (this.barcodeBookContent.length > 0) {
                var flage = true;
                for (let i in this.barcodeBookContent) {
                  if (this.barcodeBookContent[i].X == this.barpackagesize.X && this.barcodeBookContent[i].Y == this.barpackagesize.Y) {
                    flage = false;
                    if (packagesizes.P > this.barcodeBookContent[i].P) {
                      this.barcodeBookContent[i].P++;
                      this.$message({
                        message: JSON.stringify(this.barpackagesize) + '扫码成功',
                        type: 'success',
                      })
                    } else {//扫码数量不得超过调拨数量
                      this.$alert('该' + JSON.stringify(this.barpackagesize) + '已达到上限', '提示', {
                        confirmButtonText: '确定',
                        callback: action => {
                          this.$message({
                            type: 'info',
                            message: `请继续扫码!`
                          });
                        }
                      });
                      this.goodsbarcode = ''
                      return
                    }
                  }
                }
                //在barcodeBookContent没找到光度，进行添加
                if (flage) {
                  this.barpackagesize.P++
                  this.barcodeBookContent.push(this.barpackagesize)
                  this.$message({
                    message: JSON.stringify(this.barpackagesize) + '扫码成功',
                    type: 'success',
                  })
                }
              } else {//第一次扫码添加光度
                this.barpackagesize.P++
                this.barcodeBookContent.push(this.barpackagesize)
                this.$message({
                  message: JSON.stringify(this.barpackagesize) + '扫码成功',
                  type: 'success',
                })
              }
            }
          }
        }
        //商品光度 不存在提示
        if (compare) {
          this.$alert('商品光度不存在', '提示', {
            confirmButtonText: '确定',
            callback: action => {
              this.$message({
                type: 'info',
                message: `请重新扫码!`
              });
            }
          });
          this.goodsbarcode = ''
          return
        }
        if (this.showzuoyoutable) {
          this.$refs.barcodereferweibiaoleft.initBookFix(this.barcodeBookContentLeft)
          this.$refs.barcodereferweibiaoright.initBookFix(this.barcodeBookContentRight)
        }
        if (this.showerweitable) {
          this.$refs.barcodereferweibiao.initBookFix(this.barcodeBookContent)
        }
      },
      getTitle() {
        let result = "";
        let temp = localStorage.getItem("hpapi_userInfoModel")
        if (temp) {
          result += JSON.parse(temp).tenantname || ""
        }
        result += "调拨单"
        return result
      },
      handlesaleCsagreementToVoid() {

        if(this.warehousearr.length>1&&!this.warehouse){
          this.$message.error('库位必须选择！');
          return
        }

        this.loading = true;
        //判断商品扫码确认调拨数量，是否一致
        if (this.showzuoyoutable) {
          if (this.barcodeBookContentLeft.length > 0) {
            var barnumber = 0;
            var number = 0;
            for (let i in this.barcodeBookContentLeft) {
              barnumber += this.barcodeBookContentLeft[i].P
            }
            for (let j in this.BookContentLeft) {
              number += this.BookContentLeft[j].P
            }

            if (barnumber < number) {
              this.message()
              this.loading = false
              return
            }
          }
          if (this.barcodeBookContentRight.length > 0) {
            var barnumber = 0;
            var number = 0;
            for (let i in this.barcodeBookContentRight) {
              barnumber += this.barcodeBookContentRight[i].P
            }
            for (let j in this.BookContentLeft) {
              number += this.BookContentRight[j].P
            }

            if (barnumber < number) {
              this.message()
              this.loading = false
              return
            }
          }
        } else if (this.showerweitable) {
          if (this.barcodeBookContent.length > 0) {
            var barnumber = 0;
            var number = 0;
            for (let i in this.barcodeBookContent) {
              barnumber += this.barcodeBookContent[i].P
            }
            for (let j in this.BookContent) {
              number += this.BookContent[j].P
            }
            if (barnumber < number) {
              this.message()
              this.loading = false
              return
            }
          }
        }
        receiveAllocation({unitguid: this.controlData.unitguid,
          warehouse2:this.warehouse,
          warehousename2:this.warehousename}).then(response => {
          this.loading = false;
          if (response.data.code == 0) {
            this.$message({
              type: 'success',
              message: '确认收货成功!',
            });
            if(this.paramqrcodescan) {
              copyBars({erpserial: this.controlData.erpserial,cangkucode:this.controlData.cangkucode2}).then(responsBar => {})
            }
            this.dialogSeeVisible = false
            this.$emit('bindGrid')
          } else {
            this.$message.error(response.data.msg)
          }
        })
      },
      message() {
        this.$message({
          message: '商品扫码数量确认不一致',
          type: 'error'
        })
      },
      fahuo() {
        if (!this.controlData.logisticsnum || this.controlData.logisticsnum == "") {
          this.$message.error('物流方式必须选择！');
          return;
        }

        this.loading = true;
        //判断商品扫码确认调拨数量，是否一致
        if (this.showzuoyoutable) {
          if (this.barcodeBookContentLeft.length > 0) {
            var barnumber = 0;
            var number = 0;
            for (let i in this.barcodeBookContentLeft) {
              barnumber += this.barcodeBookContentLeft[i].P
            }
            for (let j in this.BookContentLeft) {
              number += this.BookContentLeft[j].P
            }

            if (barnumber < number) {
              this.message()
              this.loading = false
              return
            }
          }
          if (this.barcodeBookContentRight.length > 0) {
            var barnumber = 0;
            var number = 0;
            for (let i in this.barcodeBookContentRight) {
              barnumber += this.barcodeBookContentRight[i].P
            }
            for (let j in this.BookContentLeft) {
              number += this.BookContentRight[j].P
            }

            if (barnumber < number) {
              this.message()
              this.loading = false
              return
            }
          }
        } else if (this.showerweitable) {
          if (this.barcodeBookContent.length > 0) {
            var barnumber = 0;
            var number = 0;
            for (let i in this.barcodeBookContent) {
              barnumber += this.barcodeBookContent[i].P
            }
            for (let j in this.BookContent) {
              number += this.BookContent[j].P
            }

            if (barnumber < number) {
              this.message()
              this.loading = false
              return
            }
          }
        }
        saveAllocationStore({
          unitguid: this.controlData.unitguid,
          logisticsnum: this.controlData.logisticsnum,
          logisticsco: this.controlData.logisticsco,
        }).then(response => {
          this.loading = false;
          if (response.data.code == 0) {
            this.$message({
              type: 'success',
              message: '确认发货成功!',
            });
            if (this.$refs.QRCodeScan1) {//退货出库的时候需要保存 唯一码
              this.$refs.QRCodeScan1.saveQRCode(this.controlData.erpserial);
            }
            this.dialogSeeVisible = false
            this.$emit('bindGrid', true);
          } else {
            this.$message.error(response.data.msg)
          }
        });
      },
      getLiuYan(remark) {
        return getRemark(remark);
      },
      print1() {
        // window.print()
        this.showtitle1 = ""
        this.$nextTick(() => {
          this.$print(this.$refs.print1)
          this.showtitle1 = "none"
          this.printlogsave()
        })
      },
      show() {
        this.dialogSeeVisible = true;
      },
      initData(row, opstatus,jxcstoreDatas) {
        this.initForm()
        this.opstatus = opstatus;
        this.unitguid = row.unitguid
        this.erpserial = row.erpserial
        this.row = row;

        getDetail({unitguid: row.unitguid, erpserial: row.erpserial,tenantid:row.tenantid}).then(response => {
          this.controlData = response.data.obj;
          if(jxcstoreDatas&&this.controlData.cangkucode2) {
            for (let i in jxcstoreDatas) {
              if (jxcstoreDatas[i].cangkucode == this.controlData.cangkucode2) {
                if (jxcstoreDatas[i].warehouse) {
                  this.warehousearr = JSON.parse(jxcstoreDatas[i].warehouse);
                  if (this.warehousearr <= 1) {
                    this.warehousearr = [];
                  }
                }
                break;
              }
            }
          }
          this.jinjia = this.controlData.filltemplate
          var bookcontent = response.data.obj.bookcontent;
          this.tableData = response.data.obj.tablemaps;
          for (let i in this.tableData) {
            this.tableData[i].P = 0
            if(this.jinjia==80){
              var pa=JSON.parse(this.tableData[i].packagesize)
              this.tableData[i].model = pa.M
              this.tableData[i].color = pa.C
            }
          }
          if(this.jinjia==80){
            this.tableData.sort(function (a, b){
              if (a.model == b.model)
                return a.color.localeCompare(b.color);
              else
                return a.model.localeCompare(b.model);
            });
          }

          if (this.tableData && this.tableData.length > 0)
            this.totalNumber()
          if(this.jinjia==40){
            this.showzuoyoutable = false
            this.showerweitable = false
            this.BookContent = [];
            this.totalnumber=this.controlData.seedgooddlist[0].totalnumber
          }else {
            if (bookcontent && bookcontent.length > 0 && bookcontent[0].type) {
              this.showzuoyoutable = true
              this.showerweitable = false
              for (let i in bookcontent) {
                if (bookcontent[i].type == "L") {
                  this.BookContentLeft.push(bookcontent[i])
                }
                if (bookcontent[i].type == "R") {
                  this.BookContentRight.push(bookcontent[i])
                }
              }
            } else {
              this.showzuoyoutable = false
              this.showerweitable = true
              this.BookContent = bookcontent;
            }
          }

          //镜片(非镜架80、非定制40)查看时生成列表显示数据
          if (this.jinjia != 80 && this.jinjia != 40) {
            this.lensList = this.buildLensList();
          }
          if (response.data.printlogDOList && response.data.printlogDOList.length > 0) {
            this.printData = response.data.printlogDOList
            this.uname = this.printData[0].uname
            this.adddate = this.printData[0].adddate
          }
          if (this.controlData.filltemplate != 80&&this.controlData.filltemplate != 40)
            this.getXYRange()
          //调拨单发货  查询订单是否有人正在操作
          if (opstatus == 'fahuo' && this.controlData.status == -10) {
            this.listAlloca();
            logListData({
              erpserial: row.erpserial,
            }).then(response => {
              if (response.data.obj.length > 0) {
                //修改调拨单时需要 是否有人在操作此订单
                //当前登陆人与日志表lockuname不一致时锁定采购订单
                for (let i = 0; i < response.data.obj.length; i++) {
                  if (response.data.obj[i].casestepname == '修改调拨' || response.data.obj[i].casestepname == '调拨发货') {
                    if (response.data.obj[i].uname && this.userInfoModel.uname != response.data.obj[i].uname) {

                      this.lock = false;
                      this.lockuname = response.data.obj[i].uname;
                      break;
                    }
                  }
                }
              }
              if (this.lock) {
                //锁定功能
                this.handlelog('调拨发货');
              }
            })
          }
        });
      },
      listAlloca(){
        var now=new Date();
        var nowStr=now.getFullYear()+'-'+(now.getMonth()+1)+'-'+now.getDate()
        getjxcList({
          offset: 0,
          limit: 20,
          begindate: nowStr,
          enddate: nowStr,
          formtype: 77,
          cangkucode: this.controlData.cangkucode,
          cangkucode2: this.controlData.cangkucode2,
          datesearch: 20,
          status: 0
        }).then(response => {
          // 从当天(同发货仓+收货仓)已发货记录中，取最近一条有物流单号的 物流公司+单号 回填
          var rows = (response.data.obj && response.data.obj.rows) || [];
          for (let i = 0; i < rows.length; i++) {
            if(rows[i].logisticsnum){
              this.controlData.logisticsco=rows[i].logisticsco;
              this.controlData.logisticsnum=rows[i].logisticsnum;
              break;
            }
          }
        }).catch((error) => {
        });
      },
      getXYRange() {
        getPrice({seedcode: this.controlData.seedcode}).then((response) => {
          if (response.data.code == 0 && response.data.obj) {
            this.costpricebook = response.data.obj
          } else {
            this.costpricebook = {}
          }
          this.createPriceBook()
        })
      },
      createPriceBook() {
        if (this.showzuoyoutable) {
          this.$refs.referweibiaoleft.initBookFix(this.BookContentLeft)
          this.$refs.referweibiaoright.initBookFix(this.BookContentRight)
        }
        if (this.showerweitable) {
          this.$refs.referweibiao.initBookFix(this.BookContent)
        }
      },
      //格式化光度显示：正数前加"+"，保留两位小数
      formatXY(v) {
        v = parseFloat(v);
        if (isNaN(v)) return '';
        return (v > 0 ? '+' : '') + v.toFixed(2);
      },
      //从BookContent系列数据转换为列表项(R/L、产品名称、球镜、柱镜、数量)并按SortMap规则排序
      buildLensList() {
        let list = [];
        let seedname = this.controlData.seedname || '';
        let seedcode = this.controlData.seedcode || '';
        const pushItem = (item, type) => {
          let X = parseFloat(item.X);
          let Y = parseFloat(item.Y);
          let P = (item.P === '' || item.P === null || item.P === undefined) ? '' : parseInt(item.P);
          list.push({
            'R/L': type,
            '产品名称': seedname,
            '球镜': Y,//二维表中 Y 为球镜
            '柱镜': X,//二维表中 X 为柱镜
            '数量': P,
            seedcode: seedcode,
            '球镜显示': this.formatXY(Y),
            '柱镜显示': this.formatXY(X)
          });
        };
        if (this.showzuoyoutable) {//左右眼分布，分别提取 L/R 项
          for (let i in this.BookContentLeft) pushItem(this.BookContentLeft[i], 'L');
          for (let i in this.BookContentRight) pushItem(this.BookContentRight[i], 'R');
        } else {//单表
          for (let i in this.BookContent) pushItem(this.BookContent[i], '');
        }
        return this.sortLens(list);
      },
      //参照后端 SortMap.java 的镜片分支实现前端排序：R优先→柱镜降序→球镜降序，超过2条记录时先比商品编码
      sortLens(list) {
        list.sort(function (a, b) {
          let result = 0;
          let type1 = a['R/L'] || '', type2 = b['R/L'] || '';
          let sc1 = '' + (a.seedcode || ''), sc2 = '' + (b.seedcode || '');
          let y1 = (a['球镜'] != null && a['球镜'] !== '') ? parseFloat(a['球镜']) : -999;
          let y2 = (b['球镜'] != null && b['球镜'] !== '') ? parseFloat(b['球镜']) : -999;//球镜
          let x1 = (a['柱镜'] != null && a['柱镜'] !== '') ? parseFloat(a['柱镜']) : -999;
          let x2 = (b['柱镜'] != null && b['柱镜'] !== '') ? parseFloat(b['柱镜']) : -999;//柱镜
          if (list.length > 2 && sc1 != sc2) {//超过2条记录时先比对商品编码
            result = sc1 > sc2 ? -1 : 4;
          } else {
            if (type1 != type2) {//眼别不同，R优先
              result = (type1 == 'R') ? -2 : ((type1 == 'L' && type2 == '') ? -2 : 3);
            } else {
              if (x1 != x2) {//柱镜不同，大的在前(降序)
                result = x1 > x2 ? -3 : 2;
              } else {
                if (y1 != y2) {//球镜不同，大的在前(降序)
                  result = y1 > y2 ? -4 : 1;
                }
              }
            }
          }
          return result;
        });
        return list;
      },
      //点击商品名称打开二维码显示弹窗（兼顾左右眼效果）
      showLensQR(item) {
        this.qrTitle = (this.controlData.seedname || '') + ' ' + (this.controlData.seedcode || '');
        this.qrvisible = true;
        this.$nextTick(() => {
          if (this.showzuoyoutable) {
            if (this.$refs.qrreferweibiaoleft) this.$refs.qrreferweibiaoleft.initBookFix(this.BookContentLeft);
            if (this.$refs.qrreferweibiaoright) this.$refs.qrreferweibiaoright.initBookFix(this.BookContentRight);
          } else {
            if (this.$refs.qrreferweibiao) this.$refs.qrreferweibiao.initBookFix(this.BookContent);
          }
        });
      },
      //打印二维码弹窗
      print1qr() {
        this.qrshowtitle1 = ""
        this.$nextTick(() => {
          this.$print(this.$refs.print1qr)
          this.qrshowtitle1 = "none"
        })
      },
      tips() {
        if (this.uname) {
          return "(打印人：" + this.uname + ",时间：" + this.adddate + ")"
        } else {
          return "(未打印过)"
        }
      },
      printlogsave() {
        save({erpserial: this.controlData.erpserial}).then(response => {
          if (response.data.code == 0) {
            //this.initData(this.row);
            this.$message({
              message: '生成打印日志',
              type: 'success'
            })
          }
        })
      },
      printloglook() {
        this.$refs.printlogList.show()
        this.$refs.printlogList.initData(this.controlData.erpserial);
      },
      initForm() {
        if (this.$refs.form1 != undefined) {
          this.$refs.form1.resetFields();
        }
        this.warehouse = '';
        this.warehousename = '';
        this.warehousearr = [];

        this.column = []
        this.tableData = []
        this.unitguid = ""
        this.printData = []
        this.uname = ''
        this.adddate = ''
        this.controlData.logisticsco = ""
        this.controlData.logisticsnum = ""

        this.BookContent = []
        this.BookContentLeft = []
        this.BookContentRight = []
        this.barcodeBookContent = []
        this.barcodeBookContentLeft = []
        this.barcodeBookContentRight = []
        this.isshowbarcode = false
        this.lock = true
        this.lockuname = ''
        this.jinjia = ''
        this.tableData = []
        this.lensList = []
        this.qrvisible = false
        this.qrshowtitle1 = 'none'
        this.qrTitle = ''
        this.lensViewMode = 'table'
      }
    },
    mounted() {
      this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"))
      getParameterDetail({paraname: "快递公司"}).then(response => {
        this.parameterData = JSON.parse(response.data.obj.paracontent);
        this.controlData.logisticsco = ""
      })
      checkModuleRight({name: 'qrcodescan'}).then(reponse => {//允许使用扫码发货
        this.paramqrcodescan = reponse.data.code == 0;
      });
    },
    components: {
      printlogList,
      HandlelogList,
      TwoDimensionalTable,
      QRCodeScan
    }
  }
</script>

<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 22px;
    line-height: 16px;
    padding: 2px;
    font-size: 12px;
  }

  .query-table td.content {
    text-align: center;
  }

  .noborder td {
    border: none;
    font-size: 12px;
  }

  .lens-seed-name {
    color: #303133;
    text-decoration: none;
  }

  /* 打印时恢复默认颜色、无下划线 */
  @media print {
    .lens-seed-name {
      color: #000;
      text-decoration: none;
    }
  }


</style>





// WEBPACK FOOTER //
// src/components/warehouse/AllocationDetail.vue